// Func = limiting Scope for this file
var lastScrollTop = 0;
(function(){

	window.onload = function() {
		/*this function add a class to header when scroll down the page
		/* and change the logo by a new file if needed depending of mockup
		*/

		// scrollDownAction(20, 'scroll');

		scrollW();
		window.addEventListener('scroll', function(){
			scrollW();
		})
	};


}());

function scrollW(){
	//check scroll down or up for header styles
	let st = window.pageYOffset || document.documentElement.scrollTop;
	if(st > 80){
		if (st > lastScrollTop){
			// downscroll code
			if(!document.getElementById('header').classList.contains('down')){
				document.getElementById('header').classList.add('down');
				document.getElementById('header').classList.remove('up');
			}
		} else {
			// upscroll code
			if(!document.getElementById('header').classList.contains('up')){
				document.getElementById('header').classList.add('up');
				document.getElementById('header').classList.remove('down');
			}
		}
	} else {
		if(document.getElementById('header').classList.contains('up') || document.getElementById('header').classList.contains('down')){
			document.getElementById('header').classList.remove('up');
			document.getElementById('header').classList.remove('down');
		}
	}
	lastScrollTop = st <= 0 ? 0 : st; // For Mobile or negative scrolling
}



(function () {

	$(document).ready(function () {
		$('.read-more-btn').click(function (e) {
			e.preventDefault();
			var target = $(this).attr("href");
			$(target).slideToggle();
			$(this).toggleClass('open');
			$(this).text($(this).text() == 'read more' ? 'read less' : 'read more');
		});
		$('.tabs__nav li a').click(function (e) {
			e.preventDefault();
			var target = $(this).attr("href");
			$('.tabs__content').fadeOut(100);
			$('.tabs__nav li a').removeClass("active");
			$('.tabs__content').removeClass("active");
			$(target).fadeIn(300);
			$(target).addClass("active");
			$(this).addClass("active");
		});

		$('.icon-click').on("click", function () {
			var that = this;
			var number = $(that).parent().parent().find('.item_data').find('.item_number').text();
			var title = $(that).parent().parent().find('.item_data').find('.item_title').text();
			var description = $(that).parent().parent().find('.item_data').find('.item_description').text();
			var itemLink = $(that).parent().parent().find('.item_data').find('.item_link').text();
			var itemImage = $(that).parent().parent().find('.item_data').find('.item_image').text();
			var imageBlock = document.getElementsByClassName("thing-to-do-section");
			imageBlock[0].style.backgroundImage = "url(" + itemImage + ")";
			$('.thing_to_do_active_number').text(number);
			$('.thing_to_do_active_name_text1').text(title);
			$('.image_part_active_name_text3').text(description);
			$('.image_part_active_div').show();
			$(that).parent().parent().find('.image_part_active_div').hide();
			$('.image_part_inactive_larger_number').hide();
			$(that).parent().parent().find('.image_part_inactive_larger_number').show();
			$('.image-sec .image').css('opacity', '1');
			$(that).parent().css('opacity', '0.3');
			$(".thing_to_do_active_link").attr("href", itemLink);
		});
		$('.icon-click')[0].click();

	});
	// Mobile console dropdown
	// $('.form-heading a.button').on('click', function (e) {
	// 	e.preventDefault();
	// 	var $btn = $(this);
	// 	var $formHeading = $btn.parent();
	// 	var $btnIcon = $btn.find('.fa');
	// 	var btnIconClasses = 'fa-caret-down fa-caret-up';

	// 	if ($formHeading.hasClass('active')) {
	// 		$btnIcon.toggleClass(btnIconClasses);

	// 		$formHeading.removeClass('active').next('.dropdown').slideUp('fast', function () {
	// 			$(this).removeClass('active').removeAttr('style');
	// 		});
	// 	} else {
	// 		$btnIcon.toggleClass(btnIconClasses);

	// 		$formHeading.addClass('active').next('.dropdown').addClass('active').slideDown('fast', function () {
	// 			$(this).css('overflow', 'visible');
	// 		});
	// 	}
	// });

	// Mobile primary nav
	// if (device.isTablet()) {

	// 	$("#ojai-california-news").click(function () {
	// 		$("#ojai-ca-accommodations").toggle();
	// 		$("#ojai-ca-attractions").toggle();
	// 	});

	// }
	// if (device.isMobile()) {

	// 	$("#ojai-california-news").click(function () {
	// 		$("#ojai-ca-accommodations").toggle();
	// 		$("#ojai-ca-attractions").toggle();
	// 	});

	// }

	$("#primary-nav li").each(function () {
		if ($(this).children('.submenu').length) {
			$(this).addClass('has-menu');
		}
	});
	$(".privary-navigation__submenu").prepend('<li class="mobile-item back"><a href="#">back</a></li>')
	$('.nav-main').each(function () {
		var $this = $(this);
		// Menu icon
		var $btn = $this.find('.btn-menu');
		var $primaryNav = $('#privary-navigation');

		$btn.on('click', function () {
			if ($btn.hasClass('active')) {
				$primaryNav.css('overflow', 'hidden');
			}

			$btn.toggleClass('active');

			$primaryNav.slideToggle('fast', function () {
				if (!$btn.hasClass('active')) {
					// Remove if nav is being closed
					$primaryNav.removeAttr('style');
				} else {
					// jQuery slide adds an 'overflow': 'hidden' style. Need the overflow shown for longer subnavs
					$primaryNav.css('overflow', 'visible');
				}
			});

		});

		// Parent item
		$primaryNav.find('.privary-navigation__item.has-menu > a').on('click', function (e) {
			if ($btn.is(':visible')) {
				e.preventDefault();
				$(this).parent().find('ul.privary-navigation__submenu').show().addClass('sub-active');
			}
		});

		// "Back to Main" item
		$primaryNav.find(".mobile-item.back a").on("click", function (e) {
			e.preventDefault();
			$('.sub-active').hide().removeClass('sub-active').removeAttr('style');
		}); 
	});
}());